import { startOfDay, endOfDay } from 'date-fns';
import { SortOrder, SORT_ORDER } from '../constants';
import { DateRange } from '../types';

export const getSortOrderLabel = (value: SortOrder) =>
  value === SORT_ORDER.NEWEST ? 'Newest First' : 'Oldest First';

export const getSortOrderOptions = (onSortOrderChange: (sortOrder: SortOrder) => void) => {
  return [
    {
      label: 'Newest First',
      onClick: () => onSortOrderChange(SORT_ORDER.NEWEST),
    },
    {
      label: 'Oldest First',
      onClick: () => onSortOrderChange(SORT_ORDER.OLDEST),
    },
  ];
};

export const getHandledSelectedLevelLabel = (selectedLevel: string) =>
  selectedLevel ? selectedLevel : 'Filter by severity';

export const calculateMinDate = (createdAt?: string | null) => {
  const thirtyDaysAgo = Date.now() - 30 * 24 * 60 * 60 * 1000;

  if (!createdAt) return new Date(thirtyDaysAgo);

  try {
    const createdAtTimestamp = new Date(createdAt).getTime();
    if (!isNaN(createdAtTimestamp) && createdAtTimestamp > thirtyDaysAgo) {
      return new Date(createdAtTimestamp);
    }
  } catch (error) {
    console.error('Error parsing createdAt', error);
  }

  return new Date(thirtyDaysAgo);
};

const isStartOfLocalDay = (date: Date) => date.getTime() === startOfDay(date).getTime();

/**
 * react-date-range lands both a single-point click (from === to) and a
 * completed custom multi-day drag/click at local midnight on every boundary.
 * Single-day: from === to, expand both ends to the full day. Multi-day: from
 * !== to, but `to` already sits at the START of the last selected day, not
 * its end — left as-is, the entire last day is silently dropped from the query.
 */
export const expandToFullDayBoundaries = (startDate: Date, endDate: Date): DateRange => {
  const from = startDate.getTime();
  const to = endDate.getTime();

  if (from === to) {
    return { from: startOfDay(startDate).getTime(), to: endOfDay(endDate).getTime() };
  }

  if (isStartOfLocalDay(startDate) && isStartOfLocalDay(endDate)) {
    return { from, to: endOfDay(endDate).getTime() };
  }

  return { from, to };
};
